import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallpaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWallpaper"><Path d="M2.76887 13.4649C4.90822 12.3086 9.17003 9.5 12 9.5C14.83 9.5 19.0918 12.3086 21.2311 13.4649M13.6655 19.3041C14.7519 18.9053 16.8748 17.8741 16.5 16C16.0306 13.6528 11.5556 16.1071 10.5 14.5C9.60976 13.1446 11.2881 10.519 11.8356 9.72978M2.5 4.5H21.5V13.6071V19.5H2.5V4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWallpaper;
